import React from 'react';
import styled from 'styled-components';

import { Icon } from '@iconify/react';
// import soundIcon from '@iconify/icons-foundation/sound';
// import windyDust from '@iconify/icons-carbon/windy-dust';
// import weatherCloudy from '@iconify/icons-mdi/weather-cloudy';
// import baselineVibration from '@iconify/icons-ic/baseline-vibration';
// import bxNoEntry from '@iconify/icons-bx/bx-no-entry';
import bxsRightArrow from '@iconify/icons-bx/bxs-right-arrow';
import bxsDownArrow from '@iconify/icons-bx/bxs-down-arrow';

import mdiMapMarkerMultiple from '@iconify/icons-mdi/map-marker-multiple';
import mdiMapMarker from '@iconify/icons-mdi/map-marker';
import mdiAudio from '@iconify/icons-mdi/microphone';
import mdiVibration from '@iconify/icons-mdi/vibration';
import mdiDust from '@iconify/icons-mdi/bacteria-outline';
import mdiWeather from '@iconify/icons-mdi/weather-pouring';

import biAudio from '@iconify/icons-bi/soundwave';
import biVibration from '@iconify/icons-bi/water';
import biDust from '@iconify/icons-bi/wind';
import biWeather from '@iconify/icons-bi/cloud-rain';

import connectionIcon from '@iconify/icons-icomoon-free/connection';
import disconnectedSolid from '@iconify/icons-clarity/disconnected-solid';

import bxNoEntry from '@iconify/icons-bx/bx-no-entry';
import { connectivity_colour_lookup } from '../common/Colours';
import { useSelector } from 'react-redux';
import { getFilterStatus } from '../../store/positions/filterStatusSlice';

// import { gt as version_greater_than, lt as version_less_than } from 'semver'

const StyledNode = styled.div<{selected: boolean}>`
  padding: 0px 0px;
  display: flex;
  background: ${props => props.selected? '#233567' : '#FFF'};
  border-bottom: 1px solid ${props => props.selected? '#787f94' : '#DDD'};
`;

const ExpandedIcon = styled.div`
  padding: 15px; 
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover{
    opacity: 60%;
  }
`;

const NodeDetails = styled.div<{selected: boolean}>`
  flex-grow: 1;
  padding: 15px 10px 15px 5px;
  color: ${props => props.selected? '#FFF' : '#292D34'};
  cursor: pointer;

  &:hover{
    opacity: 60%;
  }
`;

const NodeLabel = styled.div<{type: string}>`
  font-size: ${props => props.type === 'project' ? '1rem' : (props.type === 'site' ? '.85rem' : '0.75rem')};
  display: flex;
  align-items: center;
`;

const StyledItemSymbol = styled.span<{color?: string}>`
  color: ${props => props.color? props.color : '#999'};
  font-weight: 700;
  padding-right: 0.2rem;
  margin-top: 1.5rem;
`;

const Tab = styled.div<{ depth: number }>`
  width: ${props => props.depth * 15}px;
`;

const StyledIcon = styled(Icon)`
  transform: translateY(0.2rem) !important;
  margin-left: 10px;
`;

const getIconLetter = (node) => {
  if (node.type === 'project') return 'P';
  if (node.type === 'site') return 'S';
  if (node.type === 'station' && node.instrument_type === 1) return 'N';
  if (node.type === 'station' && node.instrument_type === 2) return 'V';
  if (node.type === 'station' && node.instrument_type === 3) return 'D';
  if (node.type === 'station' && node.instrument_type === 4) return 'M';
  return '';
}


const PositionNodeStatus = (status) =>{
  if (status.status == undefined) {
    return null;
  } else {
    return <Icon color={connectivity_colour_lookup(status.status.online_status)} width='20px' height='20px' style={{marginRight: "5px"}} icon={status.status.online_status === 'offline' || status.status.online_status === 'not_measuring'? disconnectedSolid : connectionIcon}/>
  }
}

const Node = ({ node, onNodeClick, onNodeExpandClick, depth}: { node: any; onNodeClick: any; onNodeExpandClick: any; depth: number;}) => {
  // const getIcon = (node) => {
  //   if (node.type === 'project') return mdiMapMarkerMultiple;
  //   if (node.type === 'site') return mdiMapMarker;
  //   if (node.type === 'station' && node.instrument_type === 1) return mdiAudio;
  //   if (node.type === 'station' && node.instrument_type === 2) return mdiVibration;
  //   if (node.type === 'station' && node.instrument_type === 3) return mdiDust;
  //   if (node.type === 'station' && node.instrument_type === 4) return mdiWeather;
  //   return '';
  // }
  const currentStatus = useSelector(getFilterStatus);
  const listIcon = node.type === 'project'? mdiMapMarkerMultiple : (node.type === 'site'? mdiMapMarker : (node.type === 'station' && node.instrument_type === 1? biAudio : (node.type === 'station' && node.instrument_type === 2? biVibration : (node.type === 'station' && node.instrument_type === 3? biDust : biWeather))));

  // If is project, search through list of nodes as sites, then through list of site nodes as positions to check if status is online
  // If project has no sites that have online positions and isVisibleOffline is true, don't show the project
  // If site has no online positions, don't show the site
  const projectHasOnlinePosition = (node) => {
    return node.nodes.some(site => 
      site.nodes.some(station => 
        station.status && 
        (station.status.online_status === "online" || 
          station.status.online_status === "unbuffering" || 
          station.status.online_status === "delayed" ||
          station.status.online_status === "power_saving" ||
          station.status.online_status === "shortOffline"
        )
      )
    );
  };
  
  const siteHasOnlinePosition = (node) => {
    return node.nodes.some(station => 
      station.status && 
      (station.status.online_status === "online" || 
        station.status.online_status === "unbuffering" || 
        station.status.online_status === "delayed" ||
        station.status.online_status === "power_saving" ||
        station.status.online_status === "shortOffline"
      )
    );
  };
  
  const isNotStation = (node) => {
    if (node.type === 'project') {
      return projectHasOnlinePosition(node);
    } else if (node.type === 'site') {
      return siteHasOnlinePosition(node);
    }
    return false;
  };
  
  const checkNodeVisibility = (node, currentStatus) => {
    const onlineProject = node.type === 'project' && isNotStation(node) && currentStatus !== 'offline';
    const offlineProject = node.type === 'project' && currentStatus === 'offline';
  
    const onlineSite = node.type === 'site' && isNotStation(node) && currentStatus !== 'offline';
    const offlineSite = node.type === 'site' && currentStatus === 'offline';

    const allProjectAndSite = node.type != 'station' && currentStatus === 'all';
  
    const isStationWithStatus = node.type === 'station' && node.status !== undefined;
    const isVisibleOnline = isStationWithStatus && (node.status.online_status !== 'offline' && node.status.online_status !== 'not_measuring') && currentStatus !== 'offline';
    const isVisibleOffline = isStationWithStatus && (node.status.online_status === 'offline' || node.status.online_status === 'not_measuring') && currentStatus === 'offline';
    const isVisibleAll = isStationWithStatus && currentStatus === 'all';
    
    const isVisible = 
      onlineProject || 
      offlineProject || 
      onlineSite || 
      offlineSite || 
      isVisibleOnline || 
      isVisibleOffline || 
      isVisibleAll || 
      allProjectAndSite;
  
    return isVisible;
  };
  
  if (checkNodeVisibility(node, currentStatus)){
    return (
      <StyledNode selected={node.selected}>
        <Tab depth={depth}/>

        <ExpandedIcon onClick={(e) => { onNodeExpandClick(node, e) }}>
          {node.type !== 'station' && <Icon color={node.selected? '#FFF' : '#999'} width='10px' height='10px' icon={node.expanded? bxsDownArrow : bxsRightArrow} />}
        </ExpandedIcon>      
        <NodeLabel type={node.type}>
        <PositionNodeStatus status={node.status}/>
        <Icon color={node.selected? '#FFF' : '#999'} width='20px' height='20px' icon={listIcon} style={{verticalAlign: "middle"}}/>      
        </NodeLabel>
        <NodeDetails selected={node.selected} onClick={(e) => { return onNodeClick(node, e) }}>  
          <NodeLabel type={node.type}>
            <StyledItemSymbol>
              {/* <Icon color={node.selected? '#FFF' : '#999'} width='20px' height='20px' icon={listIcon} /> */}
              {/* {getIconLetter(node)} */}
            </StyledItemSymbol> {node.label}           
          </NodeLabel>
        </NodeDetails>
      </StyledNode>
    )
  } else {
    return null;
  }

}

export const RecursiveNodes = ({ menuNodes, onNodeClick, onNodeExpandClick, depth=0}: { menuNodes: any; onNodeClick: any; onNodeExpandClick: any; depth?: number;}) => {
  return (
    <React.Fragment>
      {menuNodes.map(node => (
        <React.Fragment key={node.id}>                    
        <Node key={node.id} node={node} onNodeClick={onNodeClick} onNodeExpandClick={onNodeExpandClick} depth={depth}/>        
        {typeof node.nodes !== 'undefined' && node.nodes.length > 0 && node.expanded?         
          <RecursiveNodes menuNodes={node.nodes} onNodeClick={onNodeClick} onNodeExpandClick={onNodeExpandClick} depth={depth + 1} />
          :null
        }
        </React.Fragment>
      ))}
    </React.Fragment>
  )
}